const path = require('path');
const composer = require('./composer.json');
let underpinModules = {};

require('./underpin/assets/js/core/TemplateLoader');
require('./underpin/assets/js/core/unveil');


//Map through and autoload included underpin modules
Object.keys(composer.require).map(function(repository){
  let name = path.basename(repository);
  //If the current key hasn't already been added, it must be a composer.require package
  if(!underpinModules[name] && repository.indexOf('underpin') === 0){
    underpinModules[name] = require('./vendor/underpin/' + name + '/index.js');
  }
});



// WEBPACK FOOTER //
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/index.js